package com.wintermar.inspection.core.ui.theme.color.palette

import androidx.compose.ui.graphics.Color
import com.wintermar.inspection.core.ui.theme.color.model.ColorVariant

val SuccessColorVariant = ColorVariant(
    n25 = Color(0xFFF6FEF9),
    n50 = Color(0xFFECFDF3),
    n100 = Color(0xFFD1FADF),
    n200 = Color(0xFFA6F4C5),
    n300 = Color(0xFF6CE9A6),
    n400 = Color(0xFF32D583),
    n500 = Color(0xFF12B76A),
    n600 = Color(0xFF039855),
    n700 = Color(0xFF027A48),
    n800 = Color(0xFF05603A),
    n900 = Color(0xFF054F31)
)
